import React, { FC, ReactNode } from "react";
import { Row, Col, Typography } from "antd";
import DocumentTable from "../documents/DocumentTable";
import { MineDocument } from "@mds/common/models/documents/document";
import { formatUrlToUpperCaseString } from "@mds/common/redux/utils/helpers";
import { renderTextColumn } from "../common/CoreTableCommonColumns";

interface ProjectDocumentsTabSectionProps {
  id: string;
  title?: string;
  titleLevel?: 1 | 2 | 3 | 4 | 5;
  documents: MineDocument[];
  onArchivedDocuments?: () => Promise<void>;
  onReplaceDocument?: (document: MineDocument) => void | Promise<void>;
  canArchive?: boolean;
  canReplace?: boolean;
  infoText?: string;
  header?: ReactNode;
}
const ProjectDocumentsTabSection: FC<ProjectDocumentsTabSectionProps> = ({
  documents,
  onArchivedDocuments,
  onReplaceDocument,
  id,
  title,
  titleLevel = 4,
  canArchive = true,
  canReplace = true,
  infoText = null,
  header = null,
}) => {
  const sectionTitle = title ?? formatUrlToUpperCaseString(id);

  const hasDocumentsWithLabels = documents?.some(doc => doc.label) || false;

  const additionalColumns = hasDocumentsWithLabels
    ? [renderTextColumn("label", "Document Label")]
    : [renderTextColumn("category", "Category")];

  return (
    <Row id={id}>
      <Col span={24}>
        <Typography.Title level={titleLevel}>{sectionTitle}</Typography.Title>
        {infoText && <Typography.Paragraph>{infoText}</Typography.Paragraph>}
      </Col>
      <Col span={24}>
        <DocumentTable
          documents={documents ?? []}
          documentParent={title}
          additionalColumns={additionalColumns}
          canArchiveDocuments={canArchive}
          canReplaceDocuments={canReplace}
          onArchivedDocuments={onArchivedDocuments}
          onReplaceDocument={onReplaceDocument}
          showVersionHistory={true}
          enableBulkActions={true}
          header={header}
        />
      </Col>
    </Row>
  );
};

export default ProjectDocumentsTabSection;
